import { createRoute, redirect } from '@tanstack/react-router';

import { useStore } from '@/stores';
import type { Profile } from '@/stores/profile';
import type { MerchantRoleAccessResponse } from '@/stores/role-access';

import { rootRoute } from '../__root';

const DUMMY_PROFILE: Profile = {
  name: 'Admin User',
  email: 'admin@example.com',
  address: 'Jl. Contoh No. 1',
  phone_number: '081234567890',
  role: 'Admin',
  business: {
    name: 'Demo Business',
    address: 'Jl. Bisnis No. 1',
    country: 'Indonesia',
    country_code: 'ID',
    phone_number: '081234567890',
    email: 'business@example.com',
    website: 'https://example.com',
    merchant_type: 'ENTERPRISE',
    is_approved: true,
    status: 'ACTIVE',
    logo_path: '',
    primary_color: '#3981FF',
    secondary_color: '#EBF2FF',
    header_title: 'Demo',
    button_color: '#3981FF',
    button_text_color: '#FFFFFF',
    sidebar_text_color: '#374151',
    sidebar_text_secondary_color: '#6B7280',
    theme_name: 'default',
    province: 'DKI Jakarta',
    city: 'Jakarta Selatan',
    is_main_business: true,
  },
  bank: {
    name: 'BCA',
    bank_code: '014',
    account_number: '1234567890',
    account_beneficiary: 'Admin User',
  },
  is_login_otp_enabled: false,
  is_group: false,
};

const DUMMY_ROLE_ACCESS: MerchantRoleAccessResponse = {
  code: 200,
  message: 'OK',
  status: 'success',
  data: {
    access: [
      {
        group: 'Management',
        order: 1,
        role_access: [
          {
            name: 'Dashboard',
            route: '/dashboard',
            order: 0,
          },
          {
            name: 'Users',
            route: '/users',
            order: 1,
          },
        ],
      },
    ],
    action: {},
  },
};

export const protectedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'protected',
  beforeLoad: ({ context, location }) => {
    if (!context.authStore.accessToken)
      throw redirect({
        to: '/auth/login',
        search: { redirect: location.href },
      });
  },
  loader: async () => {
    const profile = { ...DUMMY_PROFILE, email: useStore.getState().authEmail ?? '' };
    useStore.getState().setProfile(profile);
    useStore.getState().setMerchantAccess(DUMMY_ROLE_ACCESS.data);

    return { profile, roleAccess: DUMMY_ROLE_ACCESS };
  },
});
